import React from "react";
import Box from "@mui/material/Box";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import CustomFormControlLabel from "../styledComponents/customFormControlLabel.component";
import { changeRadioGroupProps as Props } from "../../types";

const FormRadioGroupInput: React.FC<Props> = ({
  value,
  items,
  onInputChange,
  termsAndConditions,
}) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          mt: { xs: "13px", sm: "15px", md: "15px", xl: "24px" },
        }}
      >
        <FormControl component="fieldset">
          {termsAndConditions && (
            <Link
              href="https://www.odoc.life/wp-content/uploads/2020/12/oDoc-SL-Doctor-Agreement-2019-ONLINE-VERSION-17-Sep-2019.pdf"
              sx={{
                fontFamily: "Avenir",
                letterSpacing: "0px",
                color: "#2685F8",
                opacity: 1,
                fontSize: { xs: "13px", sm: "15px", md: "17px", xl: "24px" },
                lineHeight: { xs: "36px", sm: "38px", md: "33px", xl: "33px" },
                mb: "18px",
                textDecoration: "underline #2685F8",
              }}
              target="_blank"
            >
              Doctor Terms & Conditions
            </Link>
          )}
          <RadioGroup
            aria-label="title"
            defaultValue={items[0]}
            name="radio-buttons-group"
            value={value}
            onChange={(e) => onInputChange(e)}
          >
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <CustomFormControlLabel value={item} />
              </React.Fragment>
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    </React.Fragment>
  );
};

export default FormRadioGroupInput;
